'use client';

import * as ReferralCodeCaptureUtils from './referral-code-capture-utils';

export function ReferralCodeCapture() {
  ReferralCodeCaptureUtils.useReferralCodeCapture();
  return null;
}
